export const MARKET = {
  SE: 'SE',
  US: 'US',
  FR: 'FR',
};
